export default __webpack_public_path__ + "assets/images/e2d7b5fa1e8ceca04e494aa2c7b0db7b.svg";